import { CommonModule } from '@angular/common';
import { Directive, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[vmDisableScroll]',
  standalone: true,
})
export class DisableScrollDirective implements OnInit, OnDestroy {
  @Input() vmDisableScroll = false;

  disableScrollClassName = 'no-scroll';

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    if (this.vmDisableScroll) {
      this.renderer.addClass(document.body, this.disableScrollClassName);
    }
  }

  ngOnDestroy() {
    if (this.vmDisableScroll) {
      this.renderer.removeClass(document.body, this.disableScrollClassName);
    }
  }
}
